module.exports = __webpack_public_path__ + "assets/eefd23c8e6da30ff3ee9385cffcc3415.png";